import type { PincodeLookupResult, SizerState } from '../domain/interfaces/SizerRepository';

export function resolveStateFromPincode(
  lookup: Pick<PincodeLookupResult, 'statename' | 'id_state'>,
  states: SizerState[]
): string {
  if (lookup.id_state != null) {
    const byId = states.find((state) => state.id === String(lookup.id_state));
    if (byId) return byId.name;
  }

  const trimmed = lookup.statename.trim();
  if (!trimmed) return '';

  const byName = states.find(
    (state) => state.name.trim().toLowerCase() === trimmed.toLowerCase()
  );
  return byName?.name ?? trimmed;
}
